import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'forest' | 'earth' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-gold text-forestDeep shadow-[0_10px_26px_rgba(201,208,218,.22)] hover:bg-goldDark',
    forest: 'bg-forest text-white shadow-[0_10px_26px_rgba(0,0,0,.45)] hover:bg-forestDeep',
    earth: 'bg-earth text-white shadow-[0_10px_26px_rgba(110,21,64,.45)] hover:bg-forest',
    outline: 'border-2 border-gold bg-transparent text-gold hover:bg-gold hover:text-forestDeep'
  };
  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-4 text-sm sm:px-8 sm:text-base'
  };
  const classes = `inline-flex items-center justify-center gap-2 rounded-lg font-extrabold uppercase tracking-wide transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-256" data-mp="omsn219f9qr9">
        {children}
        {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-257" data-mp="12m0nsyl8h6xk" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-258" data-mp="xnqpif47pq7q">
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-259" data-mp="1ccmw07qmev68" />}
    </button>;
}